import React, { Component, Fragment } from 'react'
import {
  Dialog,
} from 'react-toolbox'
import LoadingPage from './LoadingPage'
import SuccessPage from './SuccessPage'
import ErrorPage from './ErrorPage'
import CancelPage from './CancelPage'
import CSSModules from 'react-css-modules'

import styles from '../styles.scss'

class Popup extends Component {

  constructor(props) {
    super(props)
    this.state = {

    }
  }

  headerRenderer = (page) => {
    if (this.props.loadingActive) {
      return(
        <Fragment>
          <h2 className={styles.popupHeader}>Submitting Project Changes</h2>
          <hr />
        </Fragment>
      )
    } else if (page === 'error') {
      return(
        <Fragment>
          <h2 className={styles.popupHeader}>Error with Project Changes</h2>
          <hr />
        </Fragment>
      )
    } else if (page === "submit") {
      return (<Fragment>
        <h2 className={styles.popupHeader}>Finished Submission</h2>
        <hr />
      </Fragment>
      )
    } else {
      return (
        <Fragment>
          <h2 className={styles.popupHeader}>Deleting Changes to Projects</h2>
          <hr />
        </Fragment>
      )
    }
  }

  bodyRenderer = (page) => {
    if (page === 'cancel') {
      return(
        <CancelPage />
      )
    }
    if (this.props.loadingActive) {
      return (
        <LoadingPage />
      )
    }
    if (page === 'submit') {
      return (
        <SuccessPage list={this.props.changedList} errors={this.props.errors} />
      )
    } else if (page === 'error'){
      return (
        <ErrorPage errors={this.props.errors} />
      )
    }
  }

  onTogglePopup = () => {
    return this.props.onTogglePopup()
  }

  refreshPage = () => {
    window.location.reload()
  }

  escKeyHandler = (page) => {
    if (this.props.loadingActive) {
      return
    } else if (page === 'submit') {
      window.location.reload()
    } else {
      this.onTogglePopup()
    }
  }

  overlayClickHandler = (page) => {
    if (this.props.loadingActive) {
      return
    } else if (page === 'submit') {
      window.location.reload()
    } else {
      this.onTogglePopup()
    }
  }

  getActions = (page) => {
    if (page === 'cancel') {
      return [
        { label: 'Yes', onClick: this.props.clearChanges },
        { label: 'No', onClick: this.onTogglePopup }
      ]
    } else if (page === 'submit') {
      return [
        { label: "Refresh", onClick: this.refreshPage }
      ]
    } else {
      return [
        { label: 'Cancel', onClick: this.onTogglePopup }
      ]
    }
  }
  render() {
      const {
        popupActive,
        page,
      } = this.props
  
      return (
        <React.Fragment>
          <Dialog
            actions={this.getActions(page)}
            theme={styles}
            active={popupActive}
            styleName='popupContainer'
            onOverlayClick={() => this.overlayClickHandler(page)}
            onEscKeyDown={() => this.escKeyHandler(page)}
          >
            {this.headerRenderer(page)}
            {this.bodyRenderer(page)}
          </Dialog>
        </React.Fragment>
      )
    }
}

export default CSSModules(Popup, styles)